export const defaultEmploymentOrder = ['full', 'part', 'project', 'volunteer', 'probation'] as const;
export const defaultScheduleOrder = ['full_day', 'shift', 'flexible', 'remote', 'fly_in_fly_out'] as const;
export const defaultBusinessTripReadinessOrder = ['never', 'ready', 'sometimes'] as const;
export const defaultTravelTimeOrder = ['any', 'less_than_hour', 'from_hour_to_one_and_half'] as const;
